import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ScenarioCopyForm } from "src/forms/ScenarioCopyForm";
import { useScenarioCopyMutation } from "src/hooks";
import type { ScenarioCopyMutationData } from "src/hooks/scenarios";

export function ScenarioCopyDialog(props: {
  open: boolean;
  caseId: number | string;
  scenarioId: number | string;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const copyMutation = useScenarioCopyMutation(props.scenarioId);

  function handleSubmit(values: ScenarioCopyMutationData) {
    copyMutation.mutateAsync(values).then(() => {
      props.onClose();
    });
  }

  return render();

  function render() {
    return (
      <Dialog open={props.open}>
        <DialogTitle>{t("label.copyScenario")}</DialogTitle>
        <DialogContent>
          <ScenarioCopyForm
            onClose={props.onClose}
            onSubmit={handleSubmit}
            isLoading={copyMutation.isLoading}
            errors={copyMutation.error?.response?.data}
          />
        </DialogContent>
      </Dialog>
    );
  }
}
